export default __webpack_public_path__ + "static/media/Haribhoomi.d1a4a7b3.jpg";